var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotificationBell = function SvgNotificationBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.002 23a2.263 2.263 0 0 0 2.256-2.256H9.745A2.256 2.256 0 0 0 12.002 23m6.769-6.77v-5.64c0-3.464-1.85-6.363-5.077-7.13v-.768A1.69 1.69 0 0 0 12 1a1.69 1.69 0 0 0-1.692 1.692v.767c-3.238.768-5.077 3.656-5.077 7.13v5.642l-1.455 1.455c-.71.71-.214 1.93.79 1.93h14.858c1.004 0 1.512-1.22.801-1.93z"
  })));
};
export default SvgNotificationBell;